import * as Yup from 'yup';
import type { CompanyFormModel } from './CompanyForm';
import { getCompany } from '../../../providers/api/company/companyProvider';

export const companyFormValidationSchema = (
  hiddenFields: Partial<Record<keyof CompanyFormModel, boolean>>,
  preventDuplicateVatNumber: boolean,
  excludedVatNumbers: string[],
) => {
  const { address, name, vatNumber } = hiddenFields;

  return Yup.object({
    vatNumber: vatNumber
      ? Yup.string().notRequired()
      : Yup
        .string()
        .trim()
        .matches(/^\d{11}$/, 'La partita IVA deve essere composta da 11 cifre')
        .required('Il campo è obbligatorio')
        .test(
          'unique-vat',
          'Esiste già una persona giuridica associata a questa partita IVA',
          async (value) => {
            if (!preventDuplicateVatNumber) return true;
            if (!value) return true;
            if (excludedVatNumbers.includes(value)) return true;

            try {
              await getCompany(value);
              return false;
            } catch {
              return true;
            }
          },
        ),
    name: name
      ? Yup.string().notRequired()
      : Yup
        .string()
        .trim()
        .required('Il campo è obbligatorio'),
    address: address
      ? Yup.object().notRequired()
      : Yup
        .object({
          normalizedAddress: Yup.object({
            description: Yup.string().required('Il campo è obbligatorio'),
          }),
        }).required('Il campo è obbligatorio'),
  });
};
